
interface EmergencyOption {
  text: string;
  value: string;
  icon?: string;
}

interface Question {
  id: string;
  text: string;
  type: "single" | "multiple" | "scale" | "text" | "emergency" | "category-dropdown";
  options?: string[] | EmergencyOption[];
  categories?: Record<string, string[]>;
  category?: string;
  allowOther?: boolean;
  emergencyNote?: string;
}

export { type Question, type EmergencyOption };

export const assessmentQuestions: Question[] = [
  {
    id: "emergency_screening",
    text: "Let's make sure it's not an emergency",
    type: "emergency",
    options: [
      { text: "Signs of a heart attack (chest pain, pressure, heaviness, tightness or squeezing across the chest)", value: "heart_attack" },
      { text: "Signs of a stroke (face dropping on one side, can't hold both arms up, difficulty speaking, sudden confusion cannot be sure of own name or age)", value: "stroke" },
      { text: "Suicide attempt (by taking something or self-harming)", value: "suicide" },
      { text: "Severe difficulty breathing (not being able to get words out, choking or gasping)", value: "breathing" },
      { text: "Heavy bleeding (spraying, pouring or enough to make a puddle)", value: "bleeding" },
      { text: "Severe injuries (after a serious accident)", value: "injury" },
      { text: "Seizure (fit) (shaking or jerking because of a fit, or unconscious can't be woken up)", value: "seizure" },
      { text: "Sudden, rapid swelling (of the lips, mouth, throat or tongue)", value: "swelling" },
      { text: "Labour or childbirth (waters breaking, more frequent intense cramps, baby coming, or just born)", value: "childbirth" },
      { text: "None of the above", value: "none" }
    ],
    emergencyNote: "British Sign Language (BSL) speakers can make a video call to 999. Deaf people can use 18000 to contact 999 using text relay."
  },
  {
    id: "symptom_constellation",
    text: "How can I help you today?",
    type: "category-dropdown",
    categories: {
      "Muscle and Bones": [
        "Joint Pain/Stiffness",
        "Muscle Pain",
        "Broken Bone/Fracture",
        "Swelling",
        "Back Pain",
        "Bone Pain",
        "Muscle Weakness",
        "Cramps",
        "Difficulty Moving",
        "Loss of Balance/Falls"
      ],
      "Chest and Breathing": [
        "Coughing",
        "Shortness of Breath/Wheezing",
        "Chest Pain",
        "Coughing up Blood",
        "Coughing up Phlegm",
        "Sore Throat",
        "Chest Tightness",
        "Fatigue",
        "Nasal Congestion/sinus pain"
      ],
      "Abdomen and Bowels": [
        "Abdominal Pain",
        "Nausea/Vomiting",
        "Diarrhea",
        "Constipation",
        "Bloating",
        "Heartburn",
        "Loss of Appetite",
        "Change in Bowel Habits",
        "Blood in Stool"
      ],
      "Skin and Nails": [
        "Rash",
        "Itching",
        "Swelling",
        "Dry Skin",
        "Colour Change",
        "Lumps and Bumps",
        "Brittle Nails",
        "Bruising",
        "Cuts and Grazes"
      ],
      "Head and Nerves": [
        "Headache",
        "Dizziness/Loss of Balance",
        "Fainting/Loss of Consciousness",
        "Numbness/Tingling",
        "Seizures/Abnormal movements",
        "Vision Changes",
        "Hearing loss",
        "Memory Issues"
      ],
      "Heart and Blood": [
        "Chest Pain",
        "Palpitations",
        "Shortness of Breath",
        "Fainting/Loss of Consciousness",
        "Leg Swelling",
        "Extreme Tiredness",
        "Headaches",
        "Nosebleeds",
        "Pale skin",
        "Cold Hands/Feet"
      ],
      "Mental Health": [
        "Feeling Anxious",
        "Feeling Low/Sad",
        "Feeling Overwhelmed",
        "Difficulty Sleeping",
        "Loss of Appetite",
        "Hearing Voices",
        "Feeling Paranoid",
        "Thoughts of Self-Harm",
        "Thoughts of Harming Others"
      ]
    }
  },
  {
    id: "systemic_symptoms",
    text: "Do you have any of these?",
    type: "multiple",
    options: [
      "Fever/Chills",
      "Weight Gain",
      "Weight Loss",
      "Poor Sleep",
      "Night Sweats",
      "Loss of Appetite",
      "None of the above"
    ]
  },
  {
    id: "symptom_duration",
    text: "How long have you been experiencing these problems?",
    type: "single",
    options: [
      "Less than 1 hour",
      "1-6 hours",
      "6-24 hours",
      "1-3 days",
      "4-7 days",
      "1-2 weeks",
      "2-4 weeks",
      "1-3 months",
      "3-6 months",
      "Over 6 months"
    ]
  },
  {
    id: "symptom_pattern",
    text: "Are your symptoms always there?",
    type: "single",
    options: [
      "Constant – Symptoms are always present",
      "Intermittent - Symptoms come and go unpredictably",
      "Triggered – Symptoms occur with specific activities",
      "Time-related – Symptoms occur at specific times",
      "Getting worse – Symptoms are progressively worsening",
      "Getting better – Symptoms are gradually improving",
      "Fluctuating – Symptoms vary in intensity",
      "Seasonal – Symptoms related to weather/season"
    ]
  },
  {
    id: "daily_impact",
    text: "How much is this affecting your daily life? (Your ability to sleep, drive, look after yourself)",
    type: "scale",
    options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
  }
];
